import React, { FunctionComponent, Suspense } from 'react'

import { Switch, useLocation } from 'react-router-dom'
import AuthRoutes from '@/modules/Auth/auth-routes'
import MedicalSpecialitiesRoutes from '@/modules/MedicalSpecialities/medical-specialities-routes'
import MyCalllsRoutes from '@/modules/MyCalls/my-calls-routes'
import ScreeningRoutes from '@/modules/Screening/screening-routes'
import MyCardsRoutes from '@/modules/MyCards/my-cards-routes'
import ProfileRoutes from '@/modules/Profile/profile-routes'
import ScheduledRoutes from '@/modules/Attendance/submodules/Scheduled/scheduled-routes'
import ImmediateRoutes from '@/modules/Attendance/submodules/Immediate/immediate-routes'
import ScheduledWithoutPreferenceRoutes from '@/modules/Attendance/submodules/ScheduledWithoutPreference/scheduled-w-routes'
import CheckoutRoutes from '@/modules/Checkout/checkout-routes'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
import Navbar from '@/components/Navbar'
import LoadingPage from '@/components/LoadingPage'
import useRealtimeAttendance from '@/modules/RealtimeAttendance/useRealtimeAttendance'
import ConfirmContactRoutes from '@/modules/Attendance/submodules/ConfirmContact/confirm-contact-routes'
import NPSRoutes from '@/modules/NPS/nps-routes'
import VideoCallRoutes from '@/modules/VideoCall/video-call-routes'
import StaticPagesRoutes from '@/modules/StaticPages/static-pages-routes'
import PatientRegistrationRoutes from '@/modules/PatientRegistration/patient-registration-routes'
import MyBenefitsRoutes from '@/modules/Benefits/benefits-routes'
import MyConexaPlusRoutes from '@/modules/ConexaPlus/routes'
import ScrollToTop from './ScrollToTop'
import HealthTeamsRoutes from '@/modules/HealthTeams/routes'

const Router: FunctionComponent = props => {
  const { pathname } = useLocation()
  useRealtimeAttendance()

  return (
    <Suspense fallback={<LoadingPage />}>
      {!pathname.includes('login') &&
        !pathname.includes('escolha') &&
        !pathname.includes('redirecionar') &&
        !pathname.includes('esqueci-senha') &&
        !pathname.includes('trocar-senha') &&
        !pathname.includes('termos-recusados') &&
        !pathname.includes('confirmar-senha') &&
        !pathname.includes('cadastro') && <Navbar />}

      <ScrollToTop>
        <Switch {...props}>
          {MedicalSpecialitiesRoutes}
          {AuthRoutes}
          {MyCalllsRoutes}
          {ScreeningRoutes}
          {MyCardsRoutes}
          {ProfileRoutes}
          {ImmediateRoutes}
          {ScheduledWithoutPreferenceRoutes}
          {CheckoutRoutes}
          {ConfirmContactRoutes}
          <RequireAuthentication path="/avaliacao" component={NPSRoutes} />
          {VideoCallRoutes}
          {StaticPagesRoutes}
          {PatientRegistrationRoutes}
          <RequireAuthentication
            path="/atendimento-agendado"
            component={ScheduledRoutes}
          />
          {MyBenefitsRoutes}
          {MyConexaPlusRoutes}
          {HealthTeamsRoutes}
        </Switch>
      </ScrollToTop>
    </Suspense>
  )
}

export default Router
